import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=46960610&"
import script from "./reset.vue?vue&type=script&lang=js&"
export * from "./reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46960610')) {
      api.createRecord('46960610', component.options)
    } else {
      api.reload('46960610', component.options)
    }
    module.hot.accept("./reset.vue?vue&type=template&id=46960610&", function () {
      api.rerender('46960610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/password/reset.vue"
export default component.exports